var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('router-link', {
    staticClass: "text-link",
    attrs: {
      "to": "/verify-identity"
    }
  }, [_c('h6', {
    staticClass: "login-highlight"
  }, [_vm._v("Back")])]), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Verify OTP")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.verifyToken.apply(null, arguments);
      }
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "otp-input-wrapper d-flex"
  }, _vm._l(6, function (_, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.digits[index],
        expression: "digits[index]"
      }],
      key: index,
      ref: "inputs",
      refInFor: true,
      staticClass: "otp-input",
      class: {
        'highlight_otp': _vm.otpErrorFlag
      },
      attrs: {
        "type": "tel",
        "maxlength": "1",
        "autocomplete": "one-time-code",
        "disabled": _vm.isLockedOut
      },
      domProps: {
        "value": _vm.digits[index]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.digits, index, $event.target.value);
        }, function ($event) {
          return _vm.handleInput(index, $event);
        }],
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) return null;
          return _vm.handleDelete(index, $event);
        },
        "paste": function ($event) {
          $event.preventDefault();
          return _vm.handlePaste.apply(null, arguments);
        },
        "focus": _vm.clearError
      }
    });
  }), 0), _vm.otpErrorFlag ? _c('div', {
    staticClass: "valid-error text-center mt-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e(), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('button', {
    staticClass: "submit-btn next-btn",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isOtpComplete || _vm.formLoader || _vm.isLockedOut
    }
  }, [_vm.formLoader ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.formLoader ? 'Verifying...' : 'Verify OTP') + " ")], 1)])]), !_vm.isLockedOut ? _c('login-otp', {
    attrs: {
      "expirySecond": 60,
      "setSpinnerLoader": _vm.otpLoader
    },
    on: {
      "sendOTP": _vm.sendOTP
    }
  }) : _vm._e(), _vm.isLockedOut && _vm.lockoutSeconds > 0 ? _c('lockout-timer', {
    attrs: {
      "lockout-seconds": _vm.lockoutSeconds
    },
    on: {
      "lockout-expired": _vm.handleLockoutExpired
    }
  }) : _vm._e()], 1)], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding d-none d-md-block"
  }, [_c('login-in-carsoule')], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left-login d-flex"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "Company Logo"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "opt-label mb-2 d-block"
  }, [_vm._v(" Enter OTP"), _c('span', {
    staticClass: "required-sign"
  }, [_vm._v(" *")])]);

}]

export { render, staticRenderFns }